import { alt } from "@cirrus-delivery/common/_alt"

const Actions = alt.generateActions(
    "openPage",
    "tryAgain",
    "keyRequested",
    "getRequestStatus",
    "getKeySucceed",
    "getKeyFailed",
    "decryptionFailed",
    "reset",
)

export default alt.createActions(Actions)
